import type { ErrorTestFunction } from "../interface";

export const required: ErrorTestFunction = (field, { checked, value }) => {
    if (typeof checked !== "undefined") {
        return !checked && `${field} é um campo obrigatório`;
    }
    return !value && `${field} não pode estar em branco`;
};
